import type { FieldPath, FieldValues } from 'react-hook-form';
import type { FormProps } from '@/hooks/useZodForm';
import { Input } from '../Input';
import { FieldLabel } from './FieldLabel';

interface FormInputProps<TData extends FieldValues> {
  label: string;
  fieldName: FieldPath<TData>;
  formProps: FormProps<TData>;
  disabled?: boolean;
  className?: string;
}

export function FormInput<TData extends FieldValues>(props: FormInputProps<TData>) {
  const { label, fieldName, formProps, disabled = false, className } = props;
  const { register, errors } = formProps;
  const error = errors[fieldName]?.message as string | undefined;

  return (
    <FieldLabel label={label} error={error} className={className}>
      <Input {...register(fieldName)} placeholder={label} disabled={disabled} />
    </FieldLabel>
  );
}
